import styled, { createGlobalStyle } from 'styled-components';

export const CommonStyle = createGlobalStyle`
  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    padding: 0;
  }
`;

export const AppStyled = styled.div`
  overflow-x: hidden;
  width: 100%;
  min-height: 100vh;
  max-width: 1024px;
  margin: 0 auto;
`;

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: clamp(1.25rem, 5vw, 2rem);
  padding: 1.25rem;
`;

export const AppWrapper = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
`;
